<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 18
    </div>
    <div class="chapter-title">Журнал производства работ по вытрамбованию котлованов и втрамбовыванию в их дно жесткого материала</div>
    <n-items v-if="project">
      <n-input title="1. Наименование строительной организации" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="2. Наименование объекта" v-bind="$form.input('title')" :text="!editable" />
      <n-input title="3. Адрес или место расположения объекта " v-bind="$form.input('address')" :text="!editable" />
      <n-input title="4. Дата начала работ" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="5. Дата окончания работ" v-bind="$form.input('endedAt')" :text="!editable" />
      <n-input title="6. Проектная глубина котлованов, м" v-bind="$form.input('deep')" :text="!editable" />
      <n-input title="7. Форма трамбовки" v-bind="$form.input('form')" :text="!editable" />
      <n-input title="8. Размеры трамбовки: поверху, м" v-bind="$form.input('sizeTop')" :text="!editable" inline />
      <n-input title="понизу, м" v-bind="$form.input('sizeBottom')" :text="!editable" inline />
      <n-input title="высота, м" v-bind="$form.input('sizeHeight')" :text="!editable" inline />
      <n-input title="9. Масса трамбовки, т" v-bind="$form.input('mass')" :text="!editable" />
      <n-input title="10. Максимальная высота сбрасывания трамбовки, м" v-bind="$form.input('maxHeight')" :text="!editable" />
      <n-input title="11. Вид и марка базового механизма" v-bind="$form.input('typeMark')" :text="!editable" />
      <n-input title="12. Вид и объем жесткого материала, м3" v-bind="$form.input('typeValue')" :text="!editable" />
      <n-input title="13. Виды и характер дефектов котлованов при их вытрамбовываии в их дно жесткого материала" v-bind="$form.input('typeChar')" :text="!editable" />
      <n-input title="14. Дополнительные сведения о работе установки, вытрамбовывании котлованов и втрамбовывании в их дно жесткого материала" v-bind="$form.input('additionalInfo')" :text="!editable" />
      <n-input title="Представитель технического надзора" v-bind="$form.input('tech')" :text="!editable" />
      <n-input title="Представитель авторского надзора" v-bind="$form.input('authorWatch')" :text="!editable" />
      <n-input title="Ф.И.О., должность исполнителя работ" v-bind="$form.input('worker')" :text="!editable" />
      <n-input title="Ф.И.О., должность представителя строительной лаборатории" v-bind="$form.input('buildLab')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
